// extracted by mini-css-extract-plugin
export default {"seachboxOptions":"SearchboxOptions_seachboxOptions__8nl8M"};